import { Message } from "../message"
import { JobStatus } from "../service"

export enum EventType {
  STATUS_UPDATE = "STATUS_UPDATE",
  DATE_UPDATE = "DATE_UPDATE",
  MESSAGE = "MESSAGE",
  WAITING_FOR_PART = "WAITING_FOR_PART",
  TEMPORARILY_HANDED_OUT = "TEMPORARILY_HANDED_OUT",
  RE_RIDE_BIKE_WAS_PUBLISHED = "RE_RIDE_BIKE_WAS_PUBLISHED",
  ADDON_ORDER_SENT = "ADDON_ORDER_SENT",
  ADDON_ORDER_ANSWERED = "ADDON_ORDER_ANSWERED",
  ADDON_ORDER_AUTO_ACCEPTED = "ADDON_ORDER_AUTO_ACCEPTED",
  ADDON_ORDER_REVOKED = "ADDON_ORDER_REVOKED",
}

export enum EventActorType {
  STORE_USER = "STORE_USER",
  CUSTOMER = "CUSTOMER",
  SYSTEM = "SYSTEM",
}

export interface EventActor {
  type: EventActorType
  // Only set for STORE_USER, and only on the store's view of the job
  name: string | null
}

export interface BaseJobEvent {
  id: string
  jobId: string
  createdAt: Date
}

export interface StatusUpdateEvent extends BaseJobEvent {
  type: EventType.STATUS_UPDATE
  oldStatus: JobStatus
  newStatus: JobStatus
  // Null on events written before the actor was tracked
  actor: EventActor | null
}

export interface DateUpdateEvent extends BaseJobEvent {
  type: EventType.DATE_UPDATE
  oldDate: Date
  newDate: Date
}

export interface MessageEvent extends BaseJobEvent {
  type: EventType.MESSAGE
  messageId: string
  message: Message
}

export interface WaitingForPartEvent extends BaseJobEvent {
  type: EventType.WAITING_FOR_PART
  isWaiting: boolean
  expectedDeliveryDate: Date | null
}

export interface TemporarilyHandedOutEvent extends BaseJobEvent {
  type: EventType.TEMPORARILY_HANDED_OUT
  isTemporarilyHandedOut: boolean
}

export interface ReRideBikeWasPublishedEvent extends BaseJobEvent {
  type: EventType.RE_RIDE_BIKE_WAS_PUBLISHED
}

export interface AddonOrderSentEvent extends BaseJobEvent {
  type: EventType.ADDON_ORDER_SENT
  itemCount: number
}

export interface AddonOrderAnsweredEvent extends BaseJobEvent {
  type: EventType.ADDON_ORDER_ANSWERED
  itemCount: number
  acceptedCount: number
  deniedCount: number
}

export interface AddonOrderAutoAcceptedEvent extends BaseJobEvent {
  type: EventType.ADDON_ORDER_AUTO_ACCEPTED
  itemCount: number
}

export interface AddonOrderRevokedEvent extends BaseJobEvent {
  type: EventType.ADDON_ORDER_REVOKED
  itemCount: number
}

export type JobEvent =
  | StatusUpdateEvent
  | DateUpdateEvent
  | MessageEvent
  | WaitingForPartEvent
  | TemporarilyHandedOutEvent
  | ReRideBikeWasPublishedEvent
  | AddonOrderSentEvent
  | AddonOrderAnsweredEvent
  | AddonOrderAutoAcceptedEvent
  | AddonOrderRevokedEvent
